'use client';
import React from 'react';

export default function Paragraph({children}) {
	return (
		<p className='mt-4 interDisplayMedium'>
			{children}
		</p>
	)
}
